<template>
  <v-row>
    <v-col sm="8">
      <p class="chartLabel">Histórico de resultados dos procedimentos</p>
      <ProceduresChart
        :patientsRecoveredData="proceduresChart.patientsRecoveredData"
        :patientDeathsData="proceduresChart.patientDeathsData"
        :categories="proceduresChart.categories"
      />
    </v-col>
    <v-col sm="4">
      <p class="chartLabel">Contas Registradas</p>
      <AccountsChart
        :aggregateAccountsPercentage="aggregateAccountsPercentage"
        :individualAccountsPercentage="individualAccountsPercentage"
      />
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import ProceduresChart from "@/components/atoms/Home/procedures-chart";
import AccountsChart from "@/components/atoms/Home/accounts-chart";

export default {
  components: {
    ProceduresChart,
    AccountsChart
  },
  data() {
    return {
      proceduresChart: {
        patientsRecoveredData: [
          this.totalInMonthPercentage(
            this.totalRecoveredInMonth(moment().subtract(4, "month")),
            this.totalProceduresInMonth(moment().subtract(4, "month"))
          ),

          this.totalInMonthPercentage(
            this.totalRecoveredInMonth(moment().subtract(3, "month")),
            this.totalProceduresInMonth(moment().subtract(3, "month"))
          ),

          this.totalInMonthPercentage(
            this.totalRecoveredInMonth(moment().subtract(2, "month")),
            this.totalProceduresInMonth(moment().subtract(2, "month"))
          ),

          this.totalInMonthPercentage(
            this.totalRecoveredInMonth(moment().subtract(1, "month")),
            this.totalProceduresInMonth(moment().subtract(1, "month"))
          ),

          this.totalInMonthPercentage(
            this.totalRecoveredInMonth(moment()),
            this.totalProceduresInMonth(moment())
          )
        ],
        patientDeathsData: [
          this.totalInMonthPercentage(
            this.totalDeathsInMonth(moment().subtract(4, "month")),
            this.totalProceduresInMonth(moment().subtract(4, "month"))
          ),

          this.totalInMonthPercentage(
            this.totalDeathsInMonth(moment().subtract(3, "month")),
            this.totalProceduresInMonth(moment().subtract(3, "month"))
          ),

          this.totalInMonthPercentage(
            this.totalDeathsInMonth(moment().subtract(2, "month")),
            this.totalProceduresInMonth(moment().subtract(2, "month"))
          ),

          this.totalInMonthPercentage(
            this.totalDeathsInMonth(moment().subtract(1, "month")),
            this.totalProceduresInMonth(moment().subtract(1, "month"))
          ),

          this.totalInMonthPercentage(
            this.totalDeathsInMonth(moment()),
            this.totalProceduresInMonth(moment())
          )
        ],
        categories: [
          moment()
            .locale("pt-br")
            .subtract(4, "month")
            .format("MMMM"),
          moment()
            .locale("pt-br")
            .subtract(3, "month")
            .format("MMMM"),
          moment()
            .locale("pt-br")
            .subtract(2, "month")
            .format("MMMM"),
          moment()
            .locale("pt-br")
            .subtract(1, "month")
            .format("MMMM"),
          moment()
            .locale("pt-br")
            .format("MMMM")
        ]
      }
    };
  },
  methods: {
    formatDate(value) {
      return moment(value, [
        "DD-MM-YYYY HH:mm:ss",
        "YYYY-MM-DDTHH:mm:ss.SSSSZ"
      ]);
    },
    totalProceduresInMonth(month) {
      return this.procedures.filter(procedure => {
        return (
          this.formatDate(procedure.procedureDatetime) >
            month.startOf("month") &&
          this.formatDate(procedure.procedureDatetime) < month.endOf("month")
        );
      }).length;
    },
    totalDeathsInMonth(month) {
      return this.procedures.filter(procedure => {
        return (
          this.formatDate(procedure.procedureDatetime) >
            month.startOf("month") &&
          this.formatDate(procedure.procedureDatetime) < month.endOf("month") &&
          !procedure.patientSaved
        );
      }).length;
    },
    totalRecoveredInMonth(month) {
      return this.procedures.filter(procedure => {
        return (
          this.formatDate(procedure.procedureDatetime) >
            month.startOf("month") &&
          this.formatDate(procedure.procedureDatetime) < month.endOf("month") &&
          procedure.patientSaved
        );
      }).length;
    },
    totalInMonthPercentage(totalDeathsOrRecovered, totalProcedures) {
      if (totalDeathsOrRecovered === 0 && totalProcedures === 0) return 0;
      return ((totalDeathsOrRecovered / totalProcedures) * 100).toFixed();
    }
  },
  computed: {
    totalAccounts() {
      return this.accounts.length;
    },
    totalIndividualAccounts() {
      return this.accounts.filter(
        account => !(!account.isCompany && account.companyCnpj)
      ).length;
    },
    individualAccountsPercentage() {
      return Number(
        ((this.totalIndividualAccounts / this.totalAccounts) * 100).toFixed()
      );
    },
    aggregateAccountsPercentage() {
      return 100 - this.individualAccountsPercentage;
    }
  },
  props: {
    accounts: {
      type: Array,
      required: true
    },
    procedures: {
      type: Array,
      requried: true
    }
  }
};
</script>

<style scoped>
.chartLabel {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.32px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #616161;
}
</style>